module.exports = __webpack_public_path__ + "static/media/webhome_soccer.8f3d3957.png";